import React from "react";
import LegalLayout from "@/components/LegalLayout";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function ReturnPolicy() {
  const s = useSiteSettings();
  const name = s.business_name || "Gil Maakaroun";
  const email = s.contact_email || "";
  return (
    <LegalLayout
      title="Return Policy"
      seoTitle="Return Policy"
      seoDescription={`Return and refund rules for ${name} collector products and missing sticker orders.`}
      intro="Our return and refund rules — kept short and fair. Written the way we&apos;d want a friend&apos;s hobby shop to treat us."
      effectiveDate="February 2026"
      testid="return-policy-page"
    >
      <h2>Sealed products (albums, packs, boxes, accessories, merch)</h2>
      <ul>
        <li>Return window: <strong>14 days from delivery</strong>.</li>
        <li>Items must be <strong>unopened, unused, and in original condition</strong>.</li>
        <li>You cover the return shipping unless the item arrived defective or was shipped in error.</li>
      </ul>

      <h2>Sealed sticker packs and boxes</h2>
      <ul>
        <li>Sealed packs and sealed display boxes <strong>cannot be returned once opened</strong> — the fun of packs is that they&apos;re random.</li>
        <li>If an unopened pack or box arrives damaged, contact us within 48 hours of delivery.</li>
      </ul>

      <h2>Individual missing stickers</h2>
      <ul>
        <li>Individual stickers are sourced by request and are <strong>final sale</strong> once the invoice is paid and prepared.</li>
        <li>If we ship the wrong sticker, we cover a replacement or a refund — your choice.</li>
        <li>If a sticker arrives damaged during transit, contact us within 48 hours with photos.</li>
      </ul>

      <h2>Certificates</h2>
      <ul>
        <li>Certificate program fees are non-refundable once inspection is scheduled.</li>
        <li>If we are unable to certify your album, we will refund the certificate fee in full.</li>
      </ul>

      <h2>Event RSVPs</h2>
      <p>
        Event RSVPs are free and can be canceled any time from your confirmation
        email or by contacting us. No charge applies.
      </p>

      <h2>How to start a return</h2>
      <ol>
        <li>{email ? (
          <>Email <a href={`mailto:${email}`}>{email}</a> with your order number and reason.</>
        ) : (
          <>Send us a note through the <a href="/contact">Contact page</a> with your order number and reason.</>
        )}</li>
        <li>We&apos;ll reply with a return address and any authorization number needed.</li>
        <li>Ship the item back with tracking. We&apos;ll refund within{" "}
          <strong>5 business days</strong> of receiving it, to the original payment method.</li>
      </ol>

      <h2>Exchanges</h2>
      <p>
        Prefer an exchange? Say so in the return request and we&apos;ll swap the
        item instead of refunding — same 14-day window applies.
      </p>

      <h2>Damaged, defective, or wrong item</h2>
      <p>
        Our fault, our cost. We&apos;ll cover return shipping and either replace
        the item or issue a full refund, including any original shipping paid.
      </p>

      <h2>Contact</h2>
      <p>
        Return questions? {email ? (
          <>Reach us at <a href={`mailto:${email}`}>{email}</a> or via the <a href="/contact">Contact page</a>.</>
        ) : (
          <>Reach us via the <a href="/contact">Contact page</a>.</>
        )}
      </p>
    </LegalLayout>
  );
}
